import _ from 'lodash';

// A function that takes an arbitrary list of arguments,
// where each argument is a function that will compare two arguments a and b,
// and return an integer to indicate which of a or b is larger
// according to the usual rules for comparisons.
// The returned function takes two arguments a and b and, when called, will delegate to each of the passed functions
// in turn and return the first non-zero result represented as 1 or -1 according to sign.
export function compare(...comparers) {
  return (a, b) => {
    return comparers.reduce((result, comparer) => (result !== 0 ? result : Math.sign(comparer(a, b))), 0);
  };
}

// A function that takes an optional property argument and returns a comparison function
// that will compare a and b alphanumerically.  If a property argument is provided, then the value
// of this property for a and b is compared instead.
export function stringCompare(property) {
  return (a, b) => {
    if (_.isNull(property) || _.isUndefined(property)) {
      return a.localeCompare(b);
    }
    return a[property].localeCompare(b[property]);
  };
}

// A function that takes an optional property argument and returns a comparison function
// that will compare a and b with `parseFloat`.  If a property argument is provided, then the parsed value
// of this property for a and b is compared instead.
export function floatCompare(property) {
  return (a, b) => {
    if (_.isNull(property) || _.isUndefined(property)) {
      return Math.sign(parseFloat(a) - parseFloat(b));
    }
    return Math.sign(parseFloat(a[property]) - parseFloat(b[property]));
  };
}

// A function that takes a comparison function and returns an inverse function
// that will effectively reverse the sort order.
export function reverse(comparer) {
  return (a, b) => {
    return comparer(a, b) * -1;
  };
}
